import { CalloutContentModel } from '../models/callout-content.model';
import { UserRestrictionEnum } from '../models/user-restriction.enum';

export const premiumOnlyTag = 'School & Business Plans Only';

const label: string = `Team plans are great for schools or businesses looking to create a collaborative
experience for their users. With a team plan, you get:`;

export const premiumFeatures: string[] = [
  `Get unrestricted access and storage of 3D models`,
  `Improve cross-team collaboration`,
  `Publish models directly into your LMS or application`,
];

// default pricing gate messaging
export const pricingConfig: Record<UserRestrictionEnum, CalloutContentModel> = {
  [UserRestrictionEnum.BookmarkViewThresholdReached]: {
    title: 'BookmarkViewThresholdReach',
    actionText: 'Upgrade Now',
  },
  [UserRestrictionEnum.BookmarkViewLimitReached]: {
    title: `You've reached your 10 free views this month`,
    description: `You can come back next month for another 10 free views or upgrade your plan for unlimited access to over 700+ anatomy, condition, and treatment models.`,
    image: 'assets/images/biodigital-human-explore-3d-human-anatomy.jpg',
    actionText: 'Upgrade Now',
  },
  [UserRestrictionEnum.ProAccountPastDue]: {
    title: 'AccountPastDue',
    actionText: 'Upgrade Now',
  },
  [UserRestrictionEnum.BookmarkSaveThresholdReached]: {
    title: 'BookmarkSaveThresholdReached',
    actionText: 'Upgrade Now',
  },
  [UserRestrictionEnum.BookmarkSaveLimitReached]: {
    title: `You've reached your limit of 5 saved models`,
    description: `In order to save more models on your free plan, you will need to delete models in My Library or upgrade your plan.`,
    image: 'assets/images/biodigital-human-3d-model-my-library.jpg',
    actionText: 'Upgrade Now',
    secondaryActionText: 'Go to My Library to delete models',
  },
  [UserRestrictionEnum.TeamTrailExpired]: {
    title: 'TrailExpired',
    actionText: 'Upgrade Now',
  },
  [UserRestrictionEnum.Publish]: {
    title: `Publish your 3D model`,
    description: `Upgrade to publish to your learning management system, website, or application and make your 3D models available for anyone to view and interact.`,
    image: 'assets/images/biodigital-human-publish-custom-3D-model.jpg',
    tag: premiumOnlyTag,
    tagIcon: 'lock',
    actionText: 'Upgrade Now',
  },
};
